<template>
  <main class="login_h5_page">
    <backbar :tit="$t('login_h5.loginHead')"></backbar>

    <div id="fb-root"></div>
    <error-modal :msg="errorMsg" @closeModal="closeErrorModal" v-if="errorFlag"></error-modal>

    <div class="login-loading" v-if="showSpinner">
      <spinner></spinner>
    </div>

    <div class="container">
      <section class="login-box" :class="{jp: $region === 'jp', sea: $area === 'komoe-sea'}">
        <div class="login-tit">{{$t('login_h5.loginTitle')}}</div>
        <k-input
          v-if="accountType === 'phone'"
          :placeholder="$t('login_h5.insertPhone')"
          :validOptions="rules.phone"
          v-model="ruleForm.phone"
        ></k-input>
        <k-input
          v-if="accountType === 'email'"
          :placeholder="$t('login_h5.insertEmail')"
          :validOptions="rules.email"
          v-model="ruleForm.email"
        ></k-input>
        <k-input
          v-if="accountType === 'both'"
          :placeholder="$t('login.insertAccount')"
          :validOptions="rules.account"
          v-model="ruleForm.account"
        ></k-input>
        <k-input
          type="password"
          :placeholder="$t('login_h5.passwordLabel')"
          :validOptions="rules.password"
          v-model="ruleForm.password"
        ></k-input>
        <k-input
          :placeholder="$t('login_h5.pleaseInsertGraph')"
          :validOptions="rules.code"
          v-model="ruleForm.code"
          :class="{'jp-code-input': $region === 'jp'}"
        >
          <span class="code-tip modal-code" :class="$region" @click="getCode">
            <img :src="codeImg" @error="switchCaptchaLine" />
          </span>
        </k-input>

        <div class="tip-line">
          <span
            class="radio-box"
            :class="{ checked: radioChecked}"
            @click="checkRadio"
            ga-data="1001001"
          ></span>
          {{$t('login_h5.autoLoginNextTime')}}
          <router-link
            :to="findpwdUrl"
            class="tip-right"
            ga-data="1001002"
          >{{$t('login_h5.forgetPassword')}}</router-link>
        </div>
        <div class="login-box-bot">
          <div
            class="login-btn"
            :class="{allowed: submitReady}"
            @click="encryptPwd"
            ga-data="1001003"
          >{{$t('login_h5.login')}}</div>
          <div class="tip-line" v-if="$area !== 'komoe-sea' && accountType !== 'both'">
            {{$t('login_h5.noAccount')}}
            <span
              class="tip-link"
              @click="goSignup"
              ga-data="1001004"
            >{{$t('login_h5.signupNow')}}</span>
          </div>
        </div>
        <div class="slice-box">
          <span class="s-txt">{{$t('login_h5.loginWithAnother')}}</span>
        </div>

        <div class="third-login" :class="$region">
          <!-- <div class="t-log-block" :class="$region" ga-data="1001005" v-show="showTWBtn">
            <twitter
              class="tw-btn"
              :callback="$siteConfig.twitter_callback_url"
              :onSuccess="twitterSuccess"
              :onFailure="twitterFailure"
            ></twitter>
            <img class="google-icon" v-if="$region === 'jp'" src="./img/twitter.svg" />
          </div> -->
          <div class="t-log-block" @click="appleLogin" v-if="$region === 'komoe'">
            <img class="apple-icon" src="./img/ios.png" />
          </div>
          <div class="t-log-block" @click="fbLogin" ga-data="1001005" v-show="showFBBtn && $area !== 'komoe-sea' && accountType !== 'both'">
            <svg-icon name="facebook" className="third-icon grey-icon"></svg-icon>
            <svg-icon name="facebook-color" className="third-icon color-icon"></svg-icon>
          </div>
          <div
            class="t-log-block"
            v-show="showGoogleBtn"
            :class="$region"
            id="googleSignin"
            ga-data="1001006"
          >
            <div class="my-signin2 func-icon" id="googleLogin"></div>
            <img class="google-icon" v-if="$region === 'jp'" src="./img/google.svg" />
            <svg-icon v-if="$region === 'komoe'" name="google" className="third-icon grey-icon"></svg-icon>
            <svg-icon v-if="$region === 'komoe'" name="google-color" className="third-icon color-icon"></svg-icon>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import utils from "@/utils";
const { getParams } = utils;

import JSEncrypt from "jsencrypt";
import ErrorModal from "@/component/modal/error_h5.vue";
import KInput from "@/component/input/input_h5.vue";
import backbar from "@commonBackbar";
// import twitter from "@/component/twitter";
import svgIcon from '@/component/SvgIcon'
import spinner from "@/component/spinner";
import emailValidateRules from '../js/emailValidate'

export default {
  name: "index",
  components: {
    backbar,
    // twitter,
    ErrorModal,
    KInput,
    spinner,
    svgIcon
  },
  data() {
    var vm = this;
    // 表单验证账号(邮箱和手机号)是否为空及合法
    const validAccount = (value, callback) => {
      const emailPattern = emailValidateRules[vm.$area]
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('login.insertAccount')));
      } else {
        if (!value.match("^[0-9]{5,12}$") && !emailPattern.test(value) && !value.startsWith("test")) {
          this.submitReady = false;
          return callback(new Error(vm.$t('login.insertCorrectAccount')));
        } else {
          return callback(new Error("valid"));
        }
      }
    }
    var validPhone = (value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('login_h5.insertPhone')));
      } else {
        if (!value.match("^[0-9]{5,12}$") && !value.startsWith("test")) {
          return callback(new Error(vm.$t('login_h5.insertCorrectPhone')));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    var validEmail = (value, callback) => {
      const emailPattern = emailValidateRules[vm.$area]
      value += "";
      if (!value) {
        return callback(new Error(vm.$t('login_h5.insertEmail')));
      } else {
        if (!emailPattern.test(value) && !value.startsWith("test")) {
          this.submitReady = false;
          return callback(new Error(vm.$t('login_h5.insertCorrectEmail')));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    return {
      showSpinner: false,
      validPhone,
      validEmail,
      validAccount,
      showGoogleBtn: false,
      showTWBtn: false,
      showFBBtn: false,
      lineIndex: 1,
      accountType: getParams('type') === 'both' ? "both" : (this.$region === "jp" || this.$area === 'komoe-sea' ? "email" : "phone"),
      // 找回密码地址
      findpwdUrl: getParams('type') === 'both' ? '/findpwd_h5?type=both' : '/findpwd_h5',
      // showModal: false,
      minute: 10,
      errorFlag: false,
      errorMsg: "",
      codeImg: "",
      ruleForm: {
        account: "",
        phone: "",
        email: "",
        name: "",
        password: "",
        imgCode: ""
      },
      rules: {
        account: [{ validator: validAccount, trigger: "blur" }],
        phone: [{ validator: validPhone, trigger: "blur" }],
        email: [{ validator: validEmail, trigger: "blur" }],
        code: [
          {
            required: true,
            message: this.$t('login_h5.pleaseInsertGraph'),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('login_h5.insertPassword'),
            trigger: "blur"
          }
        ]
      },
      submitReady: false,
      radioChecked: false,
      // 苹果授权码
      code: null,
      // 苹果刷新token
      id_token: null,
      type_apple: 4
    };
  },
  methods: {
    twitterSuccess(e) {
      this.jpThirdLogin(3, e.data.data);
    },
    twitterFailure() {
      this.showError(this.getResCode(900001));
    },
    loadGoogleScript() {
      window.auth2 = "";
      var _this = this;
      (function(d, w) {
        var ggScript = document.createElement("script");
        ggScript.id = "google-api-client";
        ggScript.src = "https://apis.google.com/js/api:client.js";
        ggScript.async = true;
        document.head.appendChild(ggScript);
        ggScript.onload = googleScriptLoaded(w);

        function googleScriptLoaded(w) {
          if (w.gapi) {
            w.gapi.load("auth2", function() {
              w.auth2 = w.gapi.auth2.init({
                client_id: _this.$siteConfig.google_client_id,
                cookiepolicy: "single_host_origin"
              });
              _this.showGoogleBtn = true;
              _this.$nextTick(() => {
                _this.attachEve();
              });
            });
          } else {
            setTimeout(function() {
              googleScriptLoaded(w);
            }, 500);
          }
        }
      })(document, window);
    },
    loadFacebookScript() {
      window.FB = "";

      var _this = this;
      (function(d, w) {
        var fbScript = document.createElement("script");
        fbScript.id = "facebook-jssdk";
        fbScript.src = "https://connect.facebook.net/en_US/sdk.js";
        fbScript.async = true;
        document.head.appendChild(fbScript);
        fbScript.onload = fbScriptLoaded(w);

        function fbScriptLoaded(w) {
          if (w.FB) {
            w.FB.init({
              appId: _this.$siteConfig.facebook_app_id,
              cookie: true,
              xfbml: true,
              version: "v3.0"
            });
            _this.showFBBtn = true;
          } else {
            setTimeout(function() {
              fbScriptLoaded(w);
            }, 500);
          }
        }
      })(document, window);
    },
    attachSignin(element) {
      var _this = this;
      window.auth2 &&
        window.auth2.attachClickHandler(
          element,
          {},
          function(googleUser) {
            if(_this.$region === 'jp' || _this.$area === 'komoe-sea'){
              _this.jpThirdLogin(1, googleUser);
            } else {
              _this.thirdPartyLogin(googleUser);
            }
          },
          function() {
            //   console.log(JSON.stringify(error, undefined, 2));
          }
        );
    },
    attachEve() {
      this.attachSignin(document.getElementById("googleLogin"));
    },

    fbLogin() {
      var _this = this;
      window.FB &&
        window.FB.login(
          function(response) {
            if (response.authResponse) {
              //console.log(response); // dump complete info
              var access_token = response.authResponse.accessToken; //get access token
              _this.thirdPartyLogin(access_token);
            } else {
              //user hit cancel button
            }
          },
          {
            scope: "email"
          }
        );
    },
    checkRadio() {
      this.radioChecked = !this.radioChecked;
    },
    switchCaptchaLine() {
      this.getCode("switch");
    },

    // 獲取圖形驗證碼
    getCode(tag) {
      if (tag === "switch") {
        if (this.lineIndex < 20) {
          ++this.lineIndex;
        } else {
          return;
        }
      }
      if (this.accountType === 'email') {
        this.codeImg = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      }  else if (this.accountType === 'phone') {
       this.codeImg = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      } else {
        this.codeImg = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomainGlobal}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;

      }
    },
    checkValue(value, validator) {
      const cb = info => {
        return info + "";
      };
      return validator(value, cb) === "Error: valid" ? true : false;
    },
    checkAllInputs() {
      if (this.accountType === "phone") {
        this.submitReady =
          this.checkValue(this.ruleForm.phone, this.validPhone) &&
          this.ruleForm.code &&
          this.ruleForm.password
            ? true
            : false;
      } else if (this.accountType === "email") {
        this.submitReady =
          this.checkValue(this.ruleForm.email, this.validEmail) &&
          this.ruleForm.code &&
          this.ruleForm.password
            ? true
            : false;
      } else {
         this.submitReady = this.checkValue(this.ruleForm.account, this.validAccount) &&
          this.ruleForm.code &&
          this.ruleForm.password
            ? true
            : false;
      }
    },
    closeErrorModal() {
      this.errorFlag = false;
      this.getCode();

      if (this.code && this.id_token) {
        this.dealAppleCallBackParams()
      }
    },
    phoneLogin(encryptedPwd) {
      const params = {
        user: this.ruleForm.phone,
        pwd: encryptedPwd,
        captcha: this.ruleForm.code,
        keep: this.radioChecked,
        // gourl need be confered
        gourl: this.$siteConfig.go_url
      };

      this.$apis.login
        .login(
          params.user,
          params.pwd,
          params.captcha,
          params.keep,
          params.gourl
        )
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            // 跳转至redirectUrl
            this.goPrev();
          } else {
            this.handleErrorCode(res.data);
          }
        });
    },
    emailLogin(encryptedPwd) {
      const params = {
        user: this.ruleForm.email,
        pwd: encryptedPwd,
        captcha: this.ruleForm.code
      };

      this.$apis.login
        .emailLogin(params.user, params.pwd, params.captcha)
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            // 跳转至redirectUrl
            this.goPrev();
          } else {
            this.handleErrorCode(res.data);
          }
        });
    },
    login(encryptedPwd) {
      if (this.$region === "jp") {
        this.emailLogin(encryptedPwd);
      } else {
        if (this.$area === 'komoe-sea') {
          this.emailLogin(encryptedPwd);
        } else {
          this.phoneLogin(encryptedPwd);
        }
      }
    },
     // 手机号和邮箱登录
    accountLogin(encryptedPwd) {
      const params = {
        user: this.ruleForm.account,
        pwd: encryptedPwd,
        captcha: this.ruleForm.code
      };

      this.$apis.login
        .emailLogin(params.user, params.pwd, params.captcha)
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            // 跳转至redirectUrl
            this.goPrev();
          } else {
            this.handleErrorCode(res.data);
          }
        });
    },
    countDown() {
      if (this.minute > 1) {
        this.minute--;
        setTimeout(() => {
          this.countDown();
        }, 1000);
      } else {
        this.goPrev();
      }
    },
    testRedirectUrl(str) {
      var res =
        str && str.indexOf(this.$siteConfig.domainWithoutPrefix) > -1
          ? str
          : null;
      return res;
    },
    goPrev() {
      var protocol = this.$area === 'komoe-sea' ? window.location.protocol : 'https:'
      var redirectUrl = getParams("redirect");
      var directUrl = this.testRedirectUrl(redirectUrl)
        ? protocol + redirectUrl.slice(redirectUrl.indexOf("//"))
        : protocol + this.$siteConfig.domain;
      window.location.href = directUrl;
    },
    jpThirdLogin(platform, info) {
      var id_token = info.getAuthResponse ? info.getAuthResponse().id_token : '';
      var access_key = id_token ? id_token : info;
      this.showSpinner = true;
      this.$apis.login
        .loginSns(platform, platform, access_key)
        .then(res => {
          // 跳转至redirectUrl
          var code = res.data.code;
          if (code === 0) {
            this.goPrev();
          } else {
            this.handleErrorCode(res.data);
          }
        }).finally(() => {
          this.showSpinner = false;
        });
    },
    // 第三方登录
    thirdPartyLogin(info) {
      var id_token = info.getAuthResponse ? info.getAuthResponse().id_token : '';
      const params = {
        type: id_token ? 1 : 2,
        gourl: "",
        access_key: id_token ? id_token : info
      };
      this.$apis.login
        .loginOldSns(params.type, params.type, params.access_key, params.gourl)
        .then(res => {
          // 跳转至redirectUrl
          var code = res.data.code;
          if (code === 0) {
            this.goPrev();
          } else {
            this.handleErrorCode(res.data);
          }
        });
    },
    encryptPwd() {
      var _this = this;
      let output = "";
      // 请求获取 publickey
      let password = _this.ruleForm.password;
      // const params = {
      //   pwd: password
      // };

      var handleEncrypt = (res, cb) => {
        var jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(res.data.data.key);
        output = jsencrypt.encrypt(res.data.data.hash + password);
        var code = res.data.code;
        if (code === 0) {
          // 获取publickey后，执行loginFG
          cb(output);
        } else {
          _this.handleErrorCode(res.data);
        }
      };

      if (this.accountType === "email") { // 邮箱
        this.$apis.login.getEmailPublicKey().then(res => {
          handleEncrypt(res, _this.emailLogin);
        });
      } else if (this.accountType === "phone") { // 手机
        this.$apis.login.getPublicKey().then(res => {
          handleEncrypt(res, _this.login);
        });
      } else { // 邮箱和手机
        this.$apis.login.getEmailPublicKey().then(res => {
          handleEncrypt(res, _this.accountLogin);
        });
      }
    },
    goSignup() {
      var redirectUrl = this.testRedirectUrl(getParams("redirect"));
      var directUrl = redirectUrl
        ? redirectUrl
        : "https:" + this.$siteConfig.domain;

      if (getParams("redirect")) {
        this.$router.push({
          path: "/signup_h5",
          query: {
            redirect: directUrl
          }
        });
      } else {
        this.$router.push({ path: "/signup_h5" });
      }
    },
    // 苹果登录
    appleLogin() {
      window.localStorage.removeItem('redirectUrl')
      window.localStorage.removeItem('type')
      var redirectUrl = getParams("redirect");
      var type = getParams('type');
      redirectUrl && window.localStorage.setItem('redirectUrl', redirectUrl)
      type && type !== 'null' && window.localStorage.setItem('type', getParams('type'))

      window.AppleID.auth.signIn();
      // location.href = `https://appleid.apple.com/auth/authorize?client_id=com.komoe.universal.web&redirect_uri=https://www.komoejoy.com/apple_return_url&response_type=code%20id_token`;
      // location.href = `https://appleid.apple.com/auth/authorize?client_id=com.komoe.website.server&redirect_uri=https://www.komoejoy.com/apple_return_url&response_type=code%20id_token`;
      // location.href = `https://appleid.apple.com/auth/authorize?client_id=com.komoedemo.server&redirect_uri=https://www.komoejoy.com/apple_return_url&response_type=code%20id_token`;
    },
    handleErrorCode(data) {
      if (data.code == -101) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href
          }
        });
        return false;
      }
      if (this.$area !== 'komoe-sea') {
        this.errorMsg = data.message
      } else {
        const popText = this.getResCode(data.code);
        this.errorMsg = popText ? popText : this.$t('account.serverError');
      }
     
      this.errorFlag = true;
    },
    getQueryString() {
      this.code = this.$route.query.code
      this.id_token = this.$route.query.id_token
    },
    thirdPartyLoginApple() {
      const InterfaceName = getParams('type') === 'both' || window.localStorage.getItem('type') === 'both' || this.$area === 'komoe-sea' ? 'loginSns' : 'loginOldSns';
      this.$apis.login[InterfaceName](this.type_apple, this.type_apple, this.code, InterfaceName === "loginSns" ? true : '')
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            location.href = window.localStorage.getItem('redirectUrl')
          } else {
            this.errorMsg = res.data.message
            this.errorFlag = true;
          }
        });
    },
    dealAppleCallBackParams () {
      let paramStr;
      let type = window.localStorage.getItem('type')
      let redirectUrl = window.localStorage.getItem('redirectUrl')
      if (type && redirectUrl) {
        paramStr = `?type=${type}&redirectUrl=${redirectUrl}`
      } else if (type) {
        paramStr = `?type=${type}`
      } else if (redirectUrl) {
        paramStr = `?redirectUrl=${redirectUrl}`
      }

      const url = `${location.origin}${paramStr}`;
      history.pushState('', '', url)
    },
    // 加在苹果js sdk
    loadAppleScript() {
      window.AppleID = "";
      var _this = this;
      (function (d, w) {
        var appleScript = document.createElement("script");
        appleScript.id = "apple-api-client";
        appleScript.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        appleScript.async = true;
        document.head.appendChild(appleScript);
        appleScript.onload = appleScriptLoaded(w);

        function appleScriptLoaded(w) {
          if (window.AppleID) {
            window.AppleID.auth.init({
              clientId: _this.$siteConfig.apple_client_id,
              scope: 'email',
              redirectURI: _this.$siteConfig.apple_callback_url,
              // state: 'state',
              // nonce: '12312312',
              // responseMode: "form_get",
              usePopup: false,
            });
          } else {
            setTimeout(function () {
              appleScriptLoaded(w);
            }, 500);
          }
        }
      })(document, window);
    },
  },
  watch: {
    ruleForm: {
      handler: function() {
        this.checkAllInputs();
      },
      deep: true
    }
  },
  mounted() {
    this.getCode();
  },
  created() {
    this.getQueryString()
    if (this.code && this.id_token) {
      this.thirdPartyLoginApple()
    }

    if (this.$region === "komoe") {
      this.loadFacebookScript();
      // 加在苹果js sdk
      this.loadAppleScript()
    } else if (this.$region === "jp") {
      this.showTWBtn = true;
    }
    this.loadGoogleScript();
    this.$apis.common.getUserInfo(this.$utils.token("joy_jct")).then(res => {
      if (res.data.code == 0) {
        var redirectUrl = this.testRedirectUrl(getParams("redirect"));
        var directUrl = redirectUrl
          ? redirectUrl
          : "https:" + this.$siteConfig.domain;
        window.location.href = directUrl;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/views/scss/common_h5.scss";

.login-loading {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .7);
  .progress-wrap {
    position: relative;
    top: 50%;
    line-height: 0;
    transform: translateY(-50%);
    .progress {
      top: 0;
    }
  }
}

.success-tip {
  font-size: 12px;
  color: #999999;
}
.success-link {
  color: #2da2d4;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.success-mask {
  position: fixed;
  z-index: 13;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.success-pop-modal {
  margin-top: 170px;
  margin-left: 50%;
  padding: 24px 20px;
  width: 440px;
  height: 260px;
  background-color: #fff;
  border-radius: 12px;
  text-align: center;
  transform: translateX(-50%);
  overflow: hidden;
}
.success-icon {
  margin-top: -2px;
  margin-right: 5px;
  vertical-align: middle;
}
.success-btn {
  display: inline-block;
  margin-bottom: 10px;
  width: 170px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 20px;
  background-color: #2da2d4;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
  }
}
.success-line {
  margin: 40px 0;
  line-height: 22px;
  font-size: 16px;
  color: #444;
}
.success-pic {
  width: 100%;
  height: 120px;
}

.login-box {
  position: relative;
  padding: 0.1rem 0.18rem;
  .login-tit {
    margin-bottom: 0.3rem;
    font-size: 0.2rem;
    text-align: center;
    color: $cl_dark;
  }
}

.third-login {
  padding: 0.3rem 0 0;
  font-size: 0;
  text-align: center;
  &.jp {
    padding-top: 0.15rem;
  }
  .t-log-block {
    position: relative;
    display: inline-block;
    margin: 0 0.3rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    img {
      width: 100%;
      height: 100%;
    }
    &.jp {
      margin: 0 0.3rem;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 0.12rem;
      &:hover {
        background: rgba(80, 187, 229, 0.1);
        box-shadow: none;
      }
    }
    &:hover {
      box-shadow: 0 3px 6px 0 rgba(65, 103, 178, 0.3);
    }
    .google-icon {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      width: 0.4rem;
      height: 0.4rem;
      transform: translate(-50%, -50%);
    }
    .third-icon {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      transition: opacity 0.3s;
    }
    .color-icon {
      opacity: 0;
    }
    &:hover {
      .grey-icon {
        opacity: 0;
      }
      .color-icon {
        opacity: 1;
      }
    }
  }
}
.func-icon {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  // opacity: 0;
}
.fb-login-button {
  transform: scale(1.4);
}
.tip-line {
  font-size: 12px;
  line-height: 18px;
  color: #444;
  .tip-link {
    color: #2da2d4;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .tip-right {
    float: right;
    color: #444;
    text-decoration: none;
    &:hover {
      color: #2da2d4;
    }
  }
}
.slice-box {
  position: relative;
  height: 16px;
  margin-top: 40px;
  font-size: 12px;
  text-align: center;
  .s-txt {
    position: relative;
    z-index: 2;
    display: inline-block;
    padding: 0 10px;
    color: #ccc;
    background-color: #fff;
  }
  &:after {
    position: absolute;
    top: 7px;
    left: 0;
    content: "";
    width: 100%;
    border-top: 1px solid #eee;
  }
}
.code-tip {
  position: absolute;
  top: 10px;
  right: 0;
  width: 112px;
  text-align: center;
  color: #2da2d4;
  line-height: 30px;
  border-left: 1px solid #eee;
  cursor: pointer;
  &.modal-code {
    top: 0.02rem;
    right: 0.02rem;
    height: 0.36rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.18rem;
    overflow: hidden;
    width: auto;
    box-sizing: border-box;
    &.jp {
      top: 0.03rem;
      height: 0.32rem;
    }
    img {
      display: block;
      height: 100%;
    }
  }
}
.login-box-bot {
  margin-top: 0.3rem;
  text-align: center;
  .login-btn {
    display: block;
    margin-bottom: 0.2rem;
    height: 0.4rem;
    line-height: 0.4rem;
    color: #fff;
    font-size: 0.14rem;
    border-radius: 0.2rem;
    background-color: #cccccc;
    pointer-events: none;
    &.allowed {
      background-color: #2da2d4;
      transition: all 0.2s;
      cursor: pointer;
      pointer-events: auto;
      &:hover {
        box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
      }
    }
  }
}
.radio-box {
  position: relative;
  display: inline-block;
  margin-top: -2px;
  margin-right: 10px;
  width: 10px;
  height: 10px;
  border: 2px solid #ccc;
  border-radius: 3px;
  vertical-align: middle;
  cursor: pointer;
  &:hover {
    border-color: #2da2d4;
  }
  &:after {
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 5px;
    left: 4px;
    position: absolute;
    top: 2px;
    transform: rotate(45deg) scaleY(0);
    width: 4px;
    transition: transform 0.1s ease-in 0.05s;
    transform-origin: center;
  }
  &.checked {
    width: 14px;
    height: 14px;
    border: none;
    background-color: #2da2d4;
    &:after {
      transform: rotate(45deg) scaleY(1);
    }
  }
}

.code-tip {
  position: absolute;
  top: 10px;
  right: 0;
  width: 112px;
  text-align: center;
  color: #2da2d4;
  line-height: 30px;
  border-left: 1px solid #eee;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

input::-webkit-input-placeholder {
  color: #c0c4cc !important;
}
</style>

<style lang="scss">
$jpBlue: #50BBE5;

.login_h5_page {
  .login-box .k-input-wrapper {
    position: relative;
    margin-bottom: 0.2rem;
  }
  .jp-code-input {
    .k-input-input {
      font-size: 0.1rem;
    }
  }
  .code-area {
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 2;
    width: 85px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    border-right: 1px solid #eee;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
      border: none;
      color: #2da2d4;
    }
  }
}
.login-box {
  &.jp {
    .k-input-input {
      border-width: 1px;
    }
    .radio-box {
      border-width: 1px;
    }
    .tip-line .tip-link {
      color: $jpBlue;
    }
  }
}
</style>